// add all items to the cart on add to cart click
"use strict";

const atcBtn = document.querySelector("[data-atc-button]");

// Create error message element
let errorMsg = document.createElement("div");
errorMsg.className = "pdp-atc-error-msg";
errorMsg.style.display = "none";
errorMsg.style.color = "#d32f2f";
errorMsg.style.margin = "10px 0 0 0";
errorMsg.style.textAlign = "center";
errorMsg.textContent =
  "Select at least one output option (Digital Download, Thumb Drive, or Disc Set).";
atcBtn.parentNode.insertBefore(errorMsg, atcBtn.nextSibling);

const checkCart = async () => {
  const res = await fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    header: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((response) => {
    return response.json();
  });

  return res;
};

const clearCart = async () => {
  const clear = await fetch(window.Shopify.routes.root + "cart/clear.js", {
    method: "POST",
    header: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((response) => {
    return response.json();
  });

  return clear;
};

const addToCart = async (formData) => {
  const itemInCart = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("error adding to cart: ", error);
    });

  return itemInCart;
};

const handleOneKitPopup = () => {
  const okPopup = document.querySelector("[ok-popup-container]");
  const okClose = document.querySelector("[ok-close]");
  const okViewCart = document.querySelector("[ok-view-cart]");

  okPopup.classList.remove("!hidden");

  okClose.addEventListener("click", (e) => {
    e.preventDefault();
    okPopup.classList.add("!hidden");
  });
  okViewCart.addEventListener("click", (e) => {
    e.preventDefault();
    okPopup.classList.add("!hidden");
    window.location.href = "/cart";
  });
};

const handleAtcBtn = async (event) => {
  event.preventDefault();
  event.stopPropagation(); // Prevent dataLayer event from firing

  // Override fbq temporarily to prevent duplicate events
  const originalFbq = window.fbq;
  let fbqCallCount = 0;

  window.fbq = function (...args) {
    if (args[0] === "track" && args[1] === "AddToCart") {
      fbqCallCount++;
      return; // Block the call
    }
    return originalFbq.apply(this, args);
  };

  // Validation: at least one output selected
  const digitalDownloadBtn = document.querySelector(
    "[data-output-digitaldownload]"
  );
  const thumbdriveBtn = document.querySelector("[data-output-thumbdrive]");
  const discSetBtn = document.querySelector("[data-output-discset]");
  const isDigital =
    digitalDownloadBtn &&
    digitalDownloadBtn.getAttribute("data-active-kit") === "true";
  const isThumb =
    thumbdriveBtn && thumbdriveBtn.getAttribute("data-active-kit") === "true";
  const isDisc =
    discSetBtn && discSetBtn.getAttribute("data-active-kit") === "true";
  if (!isDigital && !isThumb && !isDisc) {
    errorMsg.style.display = "block";
    atcBtn.classList.add("shake");
    setTimeout(() => atcBtn.classList.remove("shake"), 500);
    return false;
  } else {
    errorMsg.style.display = "none";
  }

  const cart = await checkCart();
  let localId = Math.floor(Math.random() * 1000000);

  if (cart.item_count !== 0) {
    await clearCart();
  }

  let itemsToAdd = [];

  const activeDivs = document.querySelectorAll(`[data-active-kit="true"]`);
  const parentId = document
    .querySelector('.pdp-kit__card[data-active-kit="true"]')
    ?.getAttribute("data-var-id");

  activeDivs.forEach((div) => {
    const varId = div.getAttribute("data-var-id");

    const item = {
      id: varId,
      properties: {
        _localId: localId,
      },
      quantity: 1,
    };

    if (parentId && parentId !== varId) {
      item.parent_id = parentId;
    }

    itemsToAdd.push(item);
  });

  // add Cloud Product
  const cloudItem = {
    id: 42069346287690,
    properties: {
      _localId: localId,
    },
    quantity: 1,
    parent_id: parentId,
    selling_plan: 3640262730,
  };
  itemsToAdd.push(cloudItem);

  // add selected processing time
  const selectedProcessingTime = window.legacybox?.selectedProcessingTime;
  if (selectedProcessingTime && selectedProcessingTime.id) {
    const processingItem = {
      id: selectedProcessingTime.id,
      properties: {
        _localId: localId,
      },
      quantity: 1,
    };

    if (parentId && parentId !== selectedProcessingTime.id) {
      processingItem.parent_id = parentId;
    }

    itemsToAdd.push(processingItem);
  } else {
    // Default to standard processing if none selected
    const standardButton = document.querySelector(
      '[data-digitizing-time] .digitizing-btn[data-time="standard"]'
    );
    if (standardButton) {
      const standardId = standardButton.getAttribute("data-time-id");
      if (standardId) {
        const standardItem = {
          id: standardId,
          properties: {
            _localId: localId,
          },
          quantity: 1,
        };

        if (parentId && parentId !== standardId) {
          standardItem.parent_id = parentId;
        }

        itemsToAdd.push(standardItem);
      }
    }
  }

  // Check for discount code - prioritize sessionStorage, fallback to auto-apply setting
  let discountCode = null;
  const storageDiscount = sessionStorage.getItem("applied_discount");
  if (storageDiscount) {
    const parsedDiscount = JSON.parse(storageDiscount);
    discountCode = parsedDiscount.code;
  }
  
  else {
    discountCode = "CYBERWK";
  }
  

  const formData = {
    items: [...itemsToAdd],
  };
  
  console.warn('Add to cart payload:', formData);
  
  const addItems = await addToCart(formData);
  
  // If discount code exists and cart add was successful, update cart with discount
  if (addItems && addItems.ok && discountCode) {
    console.warn('Applying discount code:', discountCode);
    try {
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: discountCode
        })
      });
      const updatedCart = await updateResponse.json();
      console.warn('Cart updated with discount:', updatedCart);
    } catch (error) {
      console.warn('Error applying discount:', error);
    }
  }

  // Set flag to prevent duplicate Facebook events from theme.js
  window.legacyboxAtcHandled = true;

  // Fire proper combined Facebook pixel event after successful cart add
  if (typeof window.fbq !== "undefined" && addItems && addItems.ok) {
    // Get the cart data to get accurate pricing
    try {
      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
      const cartData = await cartResponse.json();

      // Find the items we just added (they'll have the same localId)
      const addedItems = cartData.items.filter(
        (item) => item.properties && item.properties._localId === localId
      );

      if (addedItems.length > 0) {
        // Calculate total value from cart data
        const totalValue = addedItems.reduce((sum, item) => {
          return sum + item.final_price / 100;
        }, 0);

        // Get product IDs (not variant IDs)
        const contentIds = addedItems.map((item) => item.product_id.toString());

        // Create contents array with accurate pricing
        const contents = addedItems.map((item) => ({
          id: item.product_id.toString(),
          quantity: item.quantity,
          item_price: item.final_price / 100,
        }));

        // Find main product for naming
        const mainProduct = addedItems.find(
          (item) => item.product_type === "Main Product"
        );

        const pixelData = {
          currency: "USD",
          content_type: "product_group",
          content_ids: contentIds,
          contents: contents,
          value: totalValue,
          num_items: addedItems.length,
          content_name: mainProduct
            ? mainProduct.product_title
            : "Legacybox Kit Bundle",
          content_category: "Main Product",
        };

        // Temporarily restore original fbq to fire our event
        window.fbq = originalFbq;

        // Fire the Facebook pixel event
        window.fbq("track", "AddToCart", pixelData);
      }
    } catch (error) {
      // Restore original fbq even on error
      window.fbq = originalFbq;
    }
  } else {
    // Restore original fbq
    window.fbq = originalFbq;
  }

  return null;
};

function updateAtcButtonState() {
  const digitalDownloadBtn = document.querySelector(
    "[data-output-digitaldownload]"
  );
  const thumbdriveBtn = document.querySelector("[data-output-thumbdrive]");
  const discSetBtn = document.querySelector("[data-output-discset]");
  const isDigital =
    digitalDownloadBtn &&
    digitalDownloadBtn.getAttribute("data-active-kit") === "true";
  const isThumb =
    thumbdriveBtn && thumbdriveBtn.getAttribute("data-active-kit") === "true";
  const isDisc =
    discSetBtn && discSetBtn.getAttribute("data-active-kit") === "true";
  if (!isDigital && !isThumb && !isDisc) {
    atcBtn.classList.add("atc-disabled");
  } else {
    atcBtn.classList.remove("atc-disabled");
  }
}

// Listen for changes on output buttons
[
  "[data-output-digitaldownload]",
  "[data-output-thumbdrive]",
  "[data-output-discset]",
].forEach((sel) => {
  const btn = document.querySelector(sel);
  if (btn) {
    btn.addEventListener("click", updateAtcButtonState);
  }
});

// Initial state
updateAtcButtonState();

atcBtn.addEventListener("click", handleAtcBtn);

// Optional: Add a simple shake animation for error feedback
const style = document.createElement("style");
style.innerHTML = `
.pdp-atc-error-msg {
  font-size: 0.95rem;
}
.pdp-main__atc-btn.shake {
  animation: shake 0.3s;
}
@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
}`;
document.head.appendChild(style);
